const dieuTriMongOptions = [
  {
    value: 0,
    label: "Phiếu số 1",
    dienBienBenh: ` Bệnh nhân vào viện vì M    cộm, vướng từ lâu, ngày càng tăng, đỏ mắt và chảy nước mắt tăng lên khi gặp gió bụi, không đau, không nhức, chưa điều trị gì
Thị lực: MP
            MT
Nhãn áp: MP mmHg
            MT mmHg
Khám:
M: Kết mạc không cương tụ, giác mạc trong, tiền phòng sạch 
Soi đáy mắt: 2M: Gai thị hồng, võng mạc áp
Chẩn đoán: M: Mộng thịt
Chỉ định: M: Phẫu thuật cắt mộng + ghép kết mạc rìa tự thân
Phương pháp vô cảm: Gây tê tại chỗ
Ngày phẫu thuật: 
Phẫu thuật viên: 
    
    
    
    
    
Duyệt Trưởng/Phó khoa
    
    
    
    
    
    
    
`,
    yLenh: `Thuốc: 
1. DD Cravit 0.5% tra M  06 lần trước mổ






`,
    thuocVaDichVu: [],
  },
  {
    value: 1,
    label: "Phiếu số 2",
    dienBienBenh: `Bệnh nhân tỉnh táo, toàn trạng ổn định





    `,
    yLenh: `Chuyển bệnh nhân lên phòng mổ
    `,
    thuocVaDichVu: [],
  },
  {
    value: 2,
    label: "Phiếu số 3",
    dienBienBenh: `Phòng mổ nhận bệnh 
HA:   mmHg
M:  lần/ phút
    
    
    
    
`,
    yLenh: ``,
    thuocVaDichVu: [],
  },
  {
    value: 3,
    label: "Phiếu số 4",
    dienBienBenh: `HA:   mmHg
M:   lần/ phút
Bàn giao bệnh nhân về nội trú
    
    
    
    
    
    
`,
    yLenh: ``,
    thuocVaDichVu: [],
  },
  {
    value: 4,
    label: "Phiếu số 5",
    dienBienBenh: `Tiếp nhận bệnh nhân về nội trú
Bệnh nhân tỉnh táo, toàn trạng ổn định
HA:   mmHg
M:   lần/ phút
Mắt mổ: 
Mảnh ghép áp tốt
Giác mạc trong
Tiền phòng sạch
Có khâu mảnh ghép. Số mũi khâu: 5
    
    
    
    
    
    
`,
    yLenh: `Chăm sóc cấp III, 01 cháo
    
    
    
    
    
    `,
    thuocVaDichVu: [],
  },
  {
    value: 5,
    label: "Phiếu số 6",
    dienBienBenh: `Bệnh nhân tỉnh táo, toàn trạng ổn định 
Mắt mổ: mảnh ghép áp tốt, giác mạc trong
    
		`,
    yLenh: `Thuốc:  
+ DD Cravit 0.5% x 01 lọ tra mắt mổ 04 lần/ ngày
+ DD Pred forte x 01 lọ tra mắt mổ 04 lần/ ngày
+ DD Sanlein 0.1% x 01 lọ tra mắt mổ 04 lần/ ngày
+ Efferalgan 500mg x 01 viên uống khi đau
Ra viện, dùng thuốc theo đơn
    
    
    
    
    
    
`,
    thuocVaDichVu: [],
  },
];

const dieuTriTTTOptions = [
  {
    value: 0,
    label: "Phiếu số 1",
    dienBienBenh: `BN thấy  M  nhìn mờ từ lâu, ngày càng tăng, không đau, không đỏ, chưa điều trị gì, vào viện.
Thị lực: MP
            MT
Nhãn áp: MP    mmHg
            MT     mmHg
Khám:
M: Kết mạc không cương tụ, giác mạc trong, tiền phòng sạch 
Soi đáy mắt: 2M: Gai thị hồng, võng mạc áp
Chẩn đoán: M: Đục thể thủy tinh 
Chỉ định: M: Phẫu thuật tán nhuyễn thể thủy tinh bằng phương pháp siêu âm có hoặc không đặt IOL 
Phương pháp vô cảm: Gây tê tại chỗ
Ngày phẫu thuật: 
Phẫu thuật viên: BS Hà/Hạnh/Khanh/ Nguyễn Thị Phương
   



Kết quả đo Javal:
K1:         K2:




Duyệt Trưởng/Phó khoa






`,
    yLenh: `Thuốc: 
1. Acetazolamid 250mg X 02 viên Uống trước mổ 30 phút
2. Kaleorid 600mg X 01 viên Uống trước mổ 30 phút
3. DD Mydrin-P tra M  01 lần trước mổ
4. DD Cravit 0.5% tra M  06 lần trước mổ





`,
    thuocVaDichVu: [],
  },
  {
    value: 1,
    label: "Phiếu số 2",
    dienBienBenh: `Bệnh nhân tỉnh táo, toàn trạng ổn định







    `,
    yLenh: `Chuyển bệnh nhân lên phòng mổ
    
    

    
    `,
    thuocVaDichVu: [],
  },
  {
    value: 2,
    label: "Phiếu số 3",
    dienBienBenh: `Phòng mổ nhận bệnh 
HA:     mmHg
M:      lần/ phút
    
    
    
    
    
`,
    yLenh: ``,
    thuocVaDichVu: [],
  },
  {
    value: 3,
    label: "Phiếu số 4",
    dienBienBenh: `HA:    mmHg
M:    lần/ phút
Bàn giao bệnh nhân về nội trú
    
    
    
    
    
    
`,
    yLenh: ``,
    thuocVaDichVu: [],
  },
  {
    value: 4,
    label: "Phiếu số 5",
    dienBienBenh: `Tiếp nhận bệnh nhân về nội trú
Bệnh nhân tỉnh táo, toàn trạng ổn định
HA: mmHg
M: lần/ phút
Mắt mổ: 
Vết mổ kín
Kết mạc cương tụ nhẹ
Giác mạc trong
Tiền phòng sạch
IOL cân, trong bao
Bán phần sau khó quan sát
    
    
    
    
    
    
    
    `,
    yLenh: `Chăm sóc cấp III, 01 cháo
    
    
    
    
    
    `,
    thuocVaDichVu: [],
  },
  {
    value: 5,
    label: "Phiếu số 6",
    dienBienBenh: `Bệnh nhân tỉnh táo, toàn trạng ổn định 
Mắt mổ: Vết mổ kín, giác mạc trong, tiền phòng sạch, IOL cân
    
    `,
    yLenh: `Thuốc:  
+ DD Cravit 0.5% x 01 lọ tra mắt mổ 06 lần/ ngày
+ DD Pred forte x 01 lọ tra mắt mổ 06 lần/ ngày
+ DD Nevanac x 01 lọ tra mắt mổ 03 lần/ ngày
+ DD Sanlein 0.1% x 01 lọ tra mắt mổ 06 lần/ ngày
+ Efferalgan 500mg x 01 viên uống khi đau
Ra viện, dùng thuốc theo đơn
    
    
    
    
    
    
`,
    thuocVaDichVu: [],
  },
];

const dieuTriKhac = [
  {
    value: 0,
    label: "Phiếu số 1",
    dienBienBenh: `







`,
    yLenh: `





`,
    thuocVaDichVu: [],
  },
  {
    value: 1,
    label: "Phiếu số 2",
    dienBienBenh: `B







    `,
    yLenh: `
    
    

    
    `,
    thuocVaDichVu: [],
  },
  {
    value: 2,
    label: "Phiếu số 3",
    dienBienBenh: `
    
    
    
    
    
`,
    yLenh: ``,
    thuocVaDichVu: [],
  },
  {
    value: 3,
    label: "Phiếu số 4",
    dienBienBenh: `
    
    
    
    
    
    
`,
    yLenh: ``,
    thuocVaDichVu: [],
  },
  {
    value: 4,
    label: "Phiếu số 5",
    dienBienBenh: `
    
    
    
    
    
    
    
    `,
    yLenh: `
    
    
    
    
    
    `,
    thuocVaDichVu: [],
  },
  {
    value: 5,
    label: "Phiếu số 6",
    dienBienBenh: `
    
    `,
    yLenh: `
    
    
    
    
    
    
`,
    thuocVaDichVu: [],
  },
];

export { dieuTriMongOptions, dieuTriTTTOptions, dieuTriKhac };
